import { render, staticRenderFns } from "./PositionSubscription.vue?vue&type=template&id=18215f63&scoped=true"
import script from "./PositionSubscription.vue?vue&type=script&lang=js"
export * from "./PositionSubscription.vue?vue&type=script&lang=js"
import style0 from "./PositionSubscription.vue?vue&type=style&index=0&id=18215f63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18215f63",
  null
  
)

export default component.exports